import axios from 'axios';

const API_BASE_URL = process.env.HOME_PAGE_URL || '';

export const fetchTestimonials = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/testimonials`);
        return response.data;
    } catch (error) {
        console.error('Error fetching testimonials:', error);
        return { success: false, data: [] };
    }
};
